import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Col, Row } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";
import { Menu, MenuItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  get_experiences_in_section_from_pages,
  update_experiences_in_section_from_pages,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import moment from "moment";
import { ReusableSlidingSearchComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import { amApi } from "../../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../../function/alert";

const AddExpToTopSection = () => {
  const { page_id, section_id } = useParams();
  const auth = useSelector((state) => state.auth);
  const [experiences, SetExperiences] = useState([]);
  const [page, setPage] = useState([]);
  const [section, setSection] = useState([]);
  const onSuccess = (_page) => {
    setPage(_page);
    if (_page?.sections?.length) {
      // let _section = _page.sections.filter((t) => {
      //   return t?.section_id == section_id;
      // });
      // if (_page?.sections?.length) {
        setSection(_page?.sections[0]);
        SetExperiences(_page?.sections[0]?.experiences);
      // }
    }
  };
  const getData = () => {
    SetExperiences([]);
    get_experiences_in_section_from_pages(
      page_id,
      section_id,
      auth?.user?.accessToken,
      onSuccess
    );
  };
  useEffect(() => {
    getData();
  }, []);

  const expclassification = (data) => {
    let newArr = [];
    for (let i of data) {
      newArr.push(i?.title);
    }
    let values = newArr?.join(" | ");
    return values;
  };
  /*********************************
   * @DESC SEARCH ACTION
   *********************************/
  const [search, setSearch] = useState("");
  const [isActive, setActive] = useState(false);
  const onChange = async (value) => {
    // console.log(value);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState(0);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /*********************************
   * @DESC DOWNLOAD ACTION
   *********************************/
  const downloadData = {
    headers: [
      { label: "Start Date", key: "StartDate" },
      { label: "End Date", key: "EndDate" },
      { label: "Active", key: "Active" },
      { label: "Page ID", key: "PageID" },
      { label: "Page Position", key: "PagePosition" },
      { label: "Section ID", key: "SectionID" },
      { label: "Section Position", key: "SectionPosition" },
      { label: "Experience ID", key: "ExpId" },
      { label: "Experience Description", key: "ExpDesc" },
      { label: "Experience Category", key: "ExpCat" },
      { label: "Experience Sub Category", key: "ExpSubCat" },
      { label: "Experience Classification", key: "ExpClassification" },
      { label: "Date Time", key: "DateCreated" },
      { label: "ShowCase", key: "ShowCase" },
    ],
    data:
      experiences?.map((_exp) => {
        return {
          StartDate: `${
            _exp?.start_date
              ? moment(_exp?.start_date).format("Do MMM YYYY")
              : ""
          }`,
          EndDate: `${
            _exp?.end_date ? moment(_exp?.end_date).format("Do MMM YYYY") : ""
          }`,
          Active: `${_exp?.status ? "Yes" : "No"}`,
          PageID: `${page?.page_id || ""}`,
          PagePosition: `${page?.position || ""}`,
          SectionID: `${section?.section_id || ""}`,
          SectionPosition: `${section?.position || ""}`,
          ExpId: `${_exp?.experience_id?.expId || ""}`,
          ExpDesc: `${_exp?.experience_id?.name || ""}`,
          ExpCat: `${_exp?.experience_id?.category?.title || ""}`,
          ExpSubCat: `${_exp?.experience_id?.subCategory?.title || ""}`,
          ExpClassification: `${
            _exp?.experience_id?.classification?.title || ""
          }`,
          DateCreated: `${
            _exp?.updatedAt ? moment(_exp?.updatedAt).format("Do MMM YYYY") : ""
          }`,
          ShowCase: `${_exp?.show_case ? "Yes" : "No"}`,
        };
      }) || [],
  };

  const changeHandler = (show_case, _id, type) => {
    console.log(show_case);
    update_experiences_in_section_from_pages(
      page_id,
      type === "STATUS"
        ? {
            status: show_case,
            page_id: page_id,
            section_id: section_id,
            experience_id: _id,
          }
        : {
            show_case: show_case,
            page_id: page_id,
            section_id: section_id,
            experience_id: _id,
          },
      auth?.user?.accessToken,
      type,
      getData
    );
  };
  const changeHandlerMerchantStatus = async (status, _id, expData) => {
    if (expData?.experience_id?.restaurantId?.experienceManagement[expData?.experience_id?.expType?.toLowerCase()])
      await amApi
        .patch(`/experience/${_id}`, { active: status })
        .then((res) => {
          successAlert("Updated Successfully");
          getData();
        })
        .catch((err) => {
          errorAlert("Something went wrong");
        });
    else errorAlert("Experience Session is Off for this restaurant")
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Add Experience to {section?.description || ""} Section
                  <br />
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <div className="text-right">
                  <NavLink
                    to={`/superadmin/experience/page/section/addexptosection/${page_id}/${section_id}`}
                    className="mr-4 px-5 py-2 btn addBtnRed f14-700"
                    style={{ color: "#f26856" }}
                  >
                    Add Experience
                  </NavLink>
                </div>
              </div>
              <Row>
                <Col md={5}>
                  <div className="d-flex  align-items-center justify-content-start">
                    <ReusableSlidingSearchComponent
                      placeholder={
                        "Experience ID,Description,Category,sub-category"
                      }
                      isActive={isActive}
                      setActive={setActive}
                      setSearch={setSearch}
                      search={search}
                      onChange={onChange}
                    />
                    <div className="f10-400" align="center">
                      <div>
                        <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <img
                            src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {[
                            { title: "Sort by", value: 0, disabled: true },
                            {
                              title: `Date & Time 🠑`,
                              value: 1,
                              disabled: false,
                            },
                            {
                              title: "Date & Time 🠓",
                              value: 2,
                              disabled: false,
                            },
                          ].map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                key={index}
                                onClick={() => setUserSort(ele.value)}
                                disabled={ele.disabled}
                                style={{ fontWeight: "700" }}
                              >
                                {ele.title}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                      </div>
                    </div>

                    <CSVDownloader
                      filename={"Page Sections"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </Col>
                <Col md={4}></Col>
                <Col md={4}></Col>
              </Row>
              <div className="Row">
                <div
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link active`}
                >
                  Add Experience to {section?.description || "Section"}
                </div>
              </div>
              <hr className="p-0 m-0" />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main mt-2">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        Start Date /<br /> End Date
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Active
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Status
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Page ID/ <br />
                        Position
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Sect ID/ <br />
                        Positon
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Experience ID
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Experience <br />
                        Description
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Experience <br />
                        Category/ <br />
                        SubCategory
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Experience <br />
                        Classification
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Last Date
                        <br /> Create/
                        <br /> Changed
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        ShowCase
                      </td>
                    </tr>
                  </thead>
                  <tbody className="w-100 super-admin-all-vendor-main-table-body">
                    {experiences?.length ? (
                      experiences
                        .filter((e) => {
                          if (search) {
                            if (
                              e?.experience_id?.name
                                .toLowerCase()
                                .includes(search.toLowerCase()) ||
                              e?.experience_id?.expId
                                .toLowerCase()
                                .includes(search.toLowerCase()) ||
                              e?.experience_id?.category?.title
                                .toLowerCase()
                                .includes(search.toLowerCase()) ||
                              e?.experience_id?.subCategory?.title
                                .toLowerCase()
                                .includes(search.toLowerCase())
                            )
                              return true;
                          } else {
                            return true;
                          }
                        })
                        .sort((a, b) => {
                          if (userSort == 1) {
                            return (
                              new Date(a.createdAt) - new Date(b.createdAt)
                            );
                          } else if (userSort == 2) {
                            return (
                              new Date(b.createdAt) - new Date(a.createdAt)
                            );
                          }
                        })
                        .map((_exp) => {
                          return (
                            <tr className="w-100 p-0" key={_exp?._id}>
                              <td className="p-0 w-100">
                                <table className="w-100">
                                  <tbody className="sd_body_css">
                                    <tr className="pl-1 text-break">
                                      <td style={{ width: "15%" }}>
                                        <div>
                                          <h5 className="font_16_m mt-3">
                                            {_exp?.start_date
                                              ? moment(_exp?.start_date).format(
                                                  "Do MMM YYYY"
                                                )
                                              : ""}
                                            <br />

                                            {_exp?.end_date
                                              ? moment(_exp?.end_date).format(
                                                  "Do MMM YYYY"
                                                )
                                              : ""}
                                          </h5>
                                        </div>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <h3 className="font_20_m">
                                          <Toggle
                                            toggleFunction={() =>
                                              changeHandler(
                                                !_exp?.status,
                                                _exp?.experience_id?._id,
                                                "STATUS"
                                              )
                                            }
                                            checked={_exp?.status}
                                          />
                                        </h3>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <h3 className="font_20_m">
                                          <Toggle
                                            toggleFunction={() =>
                                              changeHandlerMerchantStatus(
                                                !_exp?.experience_id?.active,
                                                _exp?.experience_id?._id,
                                                _exp
                                              )
                                            }
                                            checked={
                                              _exp?.experience_id?.active
                                            }
                                          />
                                        </h3>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <h3 className="font_20_m">
                                          {page?.page_id || ""}/
                                          <br />
                                          {page?.position || ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <h3 className="font_20_m">
                                          {section?.section_id || ""}/
                                          <br />
                                          {section?.position || ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <h3 className="font_20_m">
                                          {_exp?.experience_id?.expId || ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "20%" }}>
                                        <h3 className="font_20_m">
                                          {_exp?.experience_id?.name || ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <h3 className="font_20_m">
                                          {_exp?.experience_id?.category
                                            ?.title || ""}
                                          /
                                          <br />
                                          {_exp?.experience_id?.subCategory
                                            ?.title || ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <h3 className="font_20_m">
                                          {expclassification(
                                            _exp?.experience_id
                                              ?.classification || []
                                          )}
                                          {/* {_exp?.experience_id?.classification?.map((data) => { return data?.title + " "}) || ""} */}
                                        </h3>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <h3 className="font_20_m">
                                          {_exp?.updatedAt
                                            ? moment(_exp?.updatedAt).format(
                                                "Do MMM YYYY"
                                              )
                                            : ""}
                                        </h3>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <Toggle
                                          toggleFunction={() =>
                                            changeHandler(
                                              !_exp?.show_case,
                                              _exp?.experience_id?._id,
                                              "SHOWCASE"
                                            )
                                          }
                                          checked={_exp?.show_case}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          );
                        })
                    ) : (
                      <NoContent />
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddExpToTopSection;
